import { render, staticRenderFns } from "./AddBannerSidebar.vue?vue&type=template&id=6127b54c"
import script from "./AddBannerSidebar.vue?vue&type=script&lang=js"
export * from "./AddBannerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports